import { useState } from "react";
import { toast } from "sonner";
import { Copy, Link2, RefreshCw, Power } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export default function OwnerLink({ lg, reload }) {
  const [link, setLink] = useState(lg.owner_link);
  if (!link) return null;
  const act = async (action) => {
    if (action === "regenerate" && !window.confirm("Créer un nouveau lien ? L'ancien lien (et celui du courriel) ne marchera plus.")) return;
    if (action === "off" && !window.confirm("Désactiver le lien ? Le lien du courriel d'invitation sera aussi désactivé tant que tu ne le réactives pas.")) return;
    try {
      const { data } = await api.post(`/superadmin/corporate-leagues/${lg.id}/owner-link`, { action });
      setLink(data);
      toast.success(action === "regenerate" ? "Nouveau lien créé" : action === "on" ? "Lien activé" : "Lien désactivé");
      reload();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const copy = async () => {
    try { await navigator.clipboard.writeText(link.url); toast.success("Lien copié"); } catch { toast.error("Copie impossible sur cet appareil"); }
  };
  return (
    <div className="grid gap-2 rounded-xl border border-amber-300/25 bg-amber-300/[0.04] p-3 text-xs" data-testid={`corp-owner-link-${lg.id}`}>
      <p className="flex items-center gap-1.5 font-semibold text-amber-100"><Link2 size={13} /> Lien propriétaire direct (sans courriel)</p>
      <p className="text-slate-400">Envoie ce lien à {link.email} par message. La personne crée son compte ou se connecte avec cette adresse et devient propriétaire. Valable jusqu'au {new Date(link.expires_at).toLocaleDateString("fr-FR")}, une seule utilisation.</p>
      <p className={`break-all rounded-lg bg-black/30 p-2 font-mono text-[11px] ${link.active ? "text-slate-200" : "text-slate-500 line-through"}`} data-testid={`corp-owner-link-url-${lg.id}`}>{link.url}</p>
      <p className={link.active ? "text-[#B7F52A]" : "text-rose-300"} data-testid={`corp-owner-link-state-${lg.id}`}>{link.active ? "Lien actif" : "Lien désactivé : personne ne peut l'utiliser"}</p>
      <div className="flex flex-wrap gap-2">
        <button type="button" onClick={copy} disabled={!link.active} className="mpl-btn-ghost text-xs" data-testid={`corp-owner-link-copy-${lg.id}`}><Copy size={12} /> Copier</button>
        <button type="button" onClick={() => act(link.active ? "off" : "on")} className="mpl-btn-ghost text-xs" data-testid={`corp-owner-link-toggle-${lg.id}`}><Power size={12} /> {link.active ? "Désactiver" : "Activer"}</button>
        <button type="button" onClick={() => act("regenerate")} className="mpl-btn-ghost text-xs" data-testid={`corp-owner-link-regenerate-${lg.id}`}><RefreshCw size={12} /> Nouveau lien</button>
      </div>
    </div>
  );
}
